import { Tester, UISchemaElement } from "@jsonforms/core";
import { isEmpty } from "lodash";

export const optionsAre =
  (checkOptions: { [k: string]: any }): Tester =>
  (uischema: UISchemaElement): boolean => {
    if (isEmpty(uischema)) {
      return false;
    }

    const uiOptions = uischema.options || {};

    const result = Object.keys(checkOptions).every(
      (key) => uiOptions[key] === checkOptions[key],
    );

    return result;
  };
